export default {
  setStoriesCompilationState(state, payload) {
    state.compilation = payload;
  },
  mutateStoriesCompilationState(state, payload) {
    if (state.compilation) {
      state.compilation = {...state.compilation, ...payload};
    }
  },
  setStoriesCompilationLoadingState(state, payload) {
    state.compilationLoading = payload;
  },
  setStoriesCompilationsListState(state, payload) {
    state.compilationsList = payload;
  },
  setStoriesCompilationsListLoadingState(state, loading) {
    state.compilationsListLoading = loading;
  },
  setUpdateStoryLoadingState(state, payload) {
    state.updateStoryLoading = payload;
  },
  setUpdateStoriesCompilationLoadingState(state, payload) {
    state.updateCompilationLoading = payload;
  },
  setStoriesListState(state, payload) {
    state.storiesList = payload;
  },
  setStoriesMetaState(state, meta) {
    state.storiesMeta = meta;
  },
  setStoriesLoadingState(state, loading) {
    state.storiesLoading = loading;
  },
  setStoriesOptionsState(state, options) {
    state.storiesOptions = options;
  },

  setStoryState(state, payload) {
    state.story = payload;
  },
  mutateStoryState(state, payload) {
    const {collection, ...other} = payload;
    state.story = {
      ...state.story,
      ...other,
      collection: {
        ...state.story.collection,
        ...(collection || {}),
      },
    };
  },
  setStoryLoadingState(state, loading) {
    state.storyLoading = loading;
  },
  setStoryCreateLoadingState(state, payload) {
    state.storyCreateLoading = payload;
  },
  setStoryCreateInitDataState(state, payload) {
    state.storyCreateInitData = payload;
  },
};
